import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ProductPackingTypeModel } from 'src/app/shared/entities/product-packing-type.model';
import { ProductPackingTypeService } from 'src/app/shared/services/app/product-packing-type.service';

@Component({
    selector: 'app-product-packing-type-add-edit',
    templateUrl: './product-packing-type-add-edit.component.html',
    styleUrls: ['./product-packing-type-add-edit.component.scss']
})
export class ProductPackingTypeAddEditComponent implements OnInit {

    public uid: string = null;
    public productPackingTypeModel: ProductPackingTypeModel = new ProductPackingTypeModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private productPackingTypeService: ProductPackingTypeService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

        return;
    }

    onCloseDialog(product_packing_type: ProductPackingTypeModel) {
        this.ref.close(product_packing_type);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.productPackingTypeModel.uid],
            name: [this.productPackingTypeModel.name, [Validators.required, Validators.maxLength(200)]],
        });
    }

    getItem(): void {
        this.loading = true;
        this.productPackingTypeService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.productPackingTypeModel.map(response.payload);
                this.form.patchValue(this.productPackingTypeModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.productPackingTypeService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.productPackingTypeModel.map(response.payload);
                this.form.patchValue(this.productPackingTypeModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Tipul ambalajului a fost salvat cu success!'
                });
                this.ref.close(this.productPackingTypeModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {

                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }
}
